"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormikSelect = void 0;
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var morse_react_1 = require("morse-react");
var FormikSelect = function (props) {
    return (react_1.default.createElement(formik_1.Field, { name: props.name }, function (_a) {
        var field = _a.field, form = _a.form;
        return (react_1.default.createElement(morse_react_1.Select, __assign({}, props, field, { multiple: props.multiple, onChange: function (newValue) {
                var _a;
                form.setFieldValue(props.name, newValue);
                (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, newValue);
            } })));
    }));
};
exports.FormikSelect = FormikSelect;
//# sourceMappingURL=FormikSelect.js.map